import { gql } from '@apollo/client';

export const PROMOCODE_FROM_CART_QUERY = gql`
    query promoCodeFromCart(
        $period: String!
    ) {
        cart(
            period: $period
        ) {
            ... on cart {
                period
                type
                period
                discount_conditions {
                    promoCodeApplyingErrorMessage
                    promocode
                }
            }

        }
    }

`;
